<template>
  <page>
    <lazy-div :load="doInit">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New Tariff Premium</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Tariff Premium</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">View Existing Tariff Premium</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout row wrap>
              <!-- New -->
              <v-flex xs6 v-if="newMode">
                <v-autocomplete
                  :items="buscls"
                  v-model="tariffPremForm.busCls"
                  :label="tariffPremLabel.busCls"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('tariffPremForm.busCls')"
                  data-vv-name="tariffPremForm.busCls"
                  :data-vv-as="tariffPremLabel.busCls"
                  v-validate="'required'"
                  @input="doGetBcBnfTrf($event)"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ tariffPremLabel.busCls }}</v-subheader>
                <div class="queryValue" v-for="item in filterBusClsList" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode">
                <v-autocomplete
                  :items="tariff"
                  v-model="tariffPremForm.tariff"
                  :label="tariffPremLabel.tariff"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('tariffPremForm.tariff')"
                  data-vv-name="tariffPremForm.tariff"
                  :data-vv-as="tariffPremLabel.tariff"
                  v-validate="'required'"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ tariffPremLabel.tariff }}</v-subheader>
                <div class="queryValue" v-for="item in filterTariffList" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode">
                <v-autocomplete
                  :items="benefit"
                  v-model="tariffPremForm.benefit"
                  :label="tariffPremLabel.benefit"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('tariffPremForm.benefit')"
                  data-vv-name="tariffPremForm.benefit"
                  :data-vv-as="tariffPremLabel.benefit"
                  v-validate="'required'"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ tariffPremLabel.benefit }}</v-subheader>
                <div class="queryValue" v-for="item in filterBenefitList" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode">
                <v-text-field
                  v-model="tariffPremForm.totTariff"
                  :label="tariffPremLabel.totTariff"
                  :error-messages="errors.collect('tariffPremForm.totTariff')"
                  data-vv-name="tariffPremForm.totTariff"
                  :data-vv-as="tariffPremLabel.totTariff"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ tariffPremLabel.totTariff }}</v-subheader>
                <div class="queryValue">{{ tariffPremForm.totTariff }}</div>
              </v-flex>
              <v-flex xs6 v-if="newMode">
                <cal-picker
                  v-model="tariffPremForm.effDate"
                  :label="tariffPremLabel.effDate"
                  :data-vv-as="tariffPremLabel.effDate"
                  data-vv-name="tariffPremForm.effDate"
                ></cal-picker>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ tariffPremLabel.effDate }}</v-subheader>
                <div class="queryValue">{{ convertDate(tariffPremForm.effDate) }}</div>
              </v-flex>
              <v-flex xs6 v-if="!queryMode">
                <cal-picker
                  v-model="tariffPremForm.expDate"
                  :label="tariffPremLabel.expDate"
                  :data-vv-as="tariffPremLabel.expDate"
                  data-vv-name="tariffPremForm.expDate"
                  v-validate="expDateValidation"
                ></cal-picker>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ tariffPremLabel.expDate }}</v-subheader>
                <div class="queryValue">{{ convertDate(tariffPremForm.expDate) }}</div>
              </v-flex>
              <v-flex xs6 v-if="!queryMode">
                <v-text-field
                  v-model="tariffPremForm.gap"
                  :label="tariffPremLabel.gap"
                  :error-messages="errors.collect('tariffPremForm.gap')"
                  data-vv-name="tariffPremForm.gap"
                  :data-vv-as="tariffPremLabel.gap"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ tariffPremLabel.gap }}</v-subheader>
                <div class="queryValue">{{ tariffPremForm.gap }}</div>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffPremLabel.createdBy }}</v-subheader>
                <div class="queryValue">{{ tariffPremForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffPremLabel.createdDate }}</v-subheader>
                <div class="queryValue">{{ tariffPremForm.createdDate | formatDate }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ tariffPremLabel.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ tariffPremForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ tariffPremLabel.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ tariffPremForm.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>

            <v-spacer class="mt-3"></v-spacer>
            <v-layout>
              <v-flex xs6>
                <v-btn color="red darken-1" dark class=" mr-2" @click.native="doCancel">
                  Cancel
                  <v-icon right dark>mdi-cancel</v-icon>
                </v-btn>
                <v-btn v-if="!queryMode" color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
                  Save
                  <v-icon right>mdi-content-save</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import { expandURI } from '@/utils/ajax'
import clone from 'clone'

export default {
  data() {
    return {
      submitting: false,
      loading: false,
      newMode: false,
      reviewMode: false,
      queryMode: false,
      buscls: [],
      tariff: [],
      benefit: [],
      tariffPremLabel: {
        tariff: 'Tariff',
        busCls: 'Business Class',
        benefit: 'Benefit',
        totTariff: 'Total Tariff',
        effDate: 'Effective Date',
        expDate: 'Expiry Date',
        gap: 'GAP',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      tariffPremForm: {
        tariff: null,
        busCls: null,
        benefit: null,
        totTariff: '0',
        effDate: null,
        expDate: null,
        gap: '0',
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      }
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataListDropDown('buscls')
      this.getCommonDataListDropDown('tariff')
      this.getCommonDataListDropDown('benefit')
      if (this.newMode) {
        this.tariffPremForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.tariffPremForm.createdDate = new Date()
        this.tariffPremForm.effDate = new Date()
        this.tariffPremForm.expDate = this.tariffPremForm.effDate
      } else {
        this.fetchData()
      }
    },
    async fetchData() {
      const apiURI = this.menu.tariffPrem
      if (apiURI) {
        try {
          const expand = {
            busCls: this.tariffPremId.busCls,
            tariff: this.tariffPremId.tariff,
            benefit: this.tariffPremId.benefit,
            totTariff: this.tariffPremId.totTariff,
            effDate: formatDisplayDateTime2(removeTime(this.tariffPremId.effDate))
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.tariffPremForm.tariff = data.tarfPrem.tariff
            this.tariffPremForm.busCls = data.tarfPrem.busCls
            this.tariffPremForm.benefit = data.tarfPrem.benefit
            this.tariffPremForm.effDate = data.tarfPrem.effDate
            this.tariffPremForm.totTariff = data.tarfPrem.totTariff
            this.tariffPremForm.gap = data.tarfPrem.gap
            this.tariffPremForm.expDate = data.tarfPrem.expDate
            this.tariffPremForm.createdBy = data.createdBy
            this.tariffPremForm.createdDate = data.createdDate
            this.tariffPremForm.modifiedBy = data.modifiedBy
            this.tariffPremForm.modifiedDate = data.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.checkTariffPermitted().then((result) => {
            if (result) {
              this.checkBenefitPermitted().then((result) => {
                if (result) {
                  if (this.newMode) {
                    this.doCreate()
                  } else {
                    this.doUpdate()
                  }
                }
              })
            }
          })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCreate() {
      const apiURI = this.menu.createTariffPrem
      if (apiURI) {
        let messageFilters = clone(this.tariffPremForm)
        if (messageFilters.effDate !== null && messageFilters.effDate !== '') {
          messageFilters.effDate = formatDisplayDateTime2(removeTime(messageFilters.effDate))
        }

        if (messageFilters.expDate !== null && messageFilters.expDate !== '') {
          messageFilters.expDate = formatDisplayDateTime2(removeTime(messageFilters.expDate))
        }
        this.$http
          .post(apiURI, messageFilters)
          .then((result) => {
            const { data } = result
            if (data) {
              this.$router.push({ name: 'tarfPrem' })
              this.notify(data)
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateTariffPrem
      if (apiURI) {
        this.submitting = true
        let messageFilters = clone(this.tariffPremForm)
        if (messageFilters.effDate !== null && messageFilters.effDate !== '') {
          messageFilters.effDate = formatDisplayDateTime2(removeTime(messageFilters.effDate))
        }
        if (messageFilters.expDate !== null && messageFilters.expDate !== '') {
          messageFilters.expDate = formatDisplayDateTime2(removeTime(messageFilters.expDate))
        }
        try {
          const result = await this.$http.put(apiURI, messageFilters)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'tarfPrem' })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async checkTariffPermitted() {
      const apiUrl = this.menu.checkTariffPermit
      if (apiUrl) {
        try {
          const params = {
            busCls: this.tariffPremForm.busCls,
            tariff: this.tariffPremForm.tariff
          }
          const response = await this.$http.get(expandURI(apiUrl, params))
          const { data } = response.data
          this.resetMessages()
          if (data) {
            if (data === 'false') {
              const errMsg = {
                messages: [{ message: 'Not on Tariff Permitted per Business Class File xBusClsTarf.(10098)', type: 'ERROR' }]
              }
              this.message(errMsg)
              this.fieldMessage(errMsg)
              return false
            }
          }
          return true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          return false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    doGetBcBnfTrf(event) {
      if (this.tariffPremForm.busCls !== '') {
        this.loading = true
        this.benefit = []
        this.tariff = []
        this.$validator.validate('tariffPremForm.busCls').then((result) => {
          if (result) {
            const apiURI = this.menu.getBcBenfit
            const apiURI2 = this.menu.getBcTariff
            if (apiURI) {
              const expand = {
                busCls: this.tariffPremForm.busCls
              }
              this.$http
                .get(expandURI(apiURI, expand))
                .then((result) => {
                  const { data } = result.data
                  if (data) {
                    data.filter((list) => {
                      this.benefit.push({ value: list.value, label: list.label })
                    })
                  } else {
                    this.loading = true
                    this.benefit = []
                  }
                })
                .catch((err) => {
                  this.benefit = []
                  const { data } = err.response
                  if (data) {
                    // this.message(data)
                    this.fieldMessage(data)
                    this.notify(data)
                  }
                })
            }
            if (apiURI2) {
              const expand = {
                busCls: this.tariffPremForm.busCls
              }
              this.$http
                .get(expandURI(apiURI2, expand))
                .then((result) => {
                  const { data } = result.data
                  if (data) {
                    data.filter((list) => {
                      this.tariff.push({ value: list.value, label: list.label })
                    })
                  } else {
                    this.loading = true
                    this.tariff = []
                  }
                })
                .catch((err) => {
                  this.tariff = []
                  const { data } = err.response
                  if (data) {
                    // this.message(data)
                    this.fieldMessage(data)
                    this.notify(data)
                  }
                })
            }
          } else {
            // this.loading = true
            this.tariffPremForm.benefit = null
            this.tariffPremForm.tariff = null
            this.getCommonDataList('benefit')
            this.getCommonDataList('tariff')
          }
        })
      }
    },
    async checkBenefitPermitted() {
      const apiUrl = this.menu.checkBenefitPermit
      if (apiUrl) {
        try {
          const params = {
            busCls: this.tariffPremForm.busCls,
            benefit: this.tariffPremForm.benefit
          }
          const response = await this.$http.get(expandURI(apiUrl, params))
          const { data } = response.data
          this.resetMessages()
          if (data) {
            if (data === 'false') {
              const errMsg = {
                messages: [{ message: 'Not found in Permitted Benefit per Business Class file.(10462)', type: 'ERROR' }]
              }
              this.message(errMsg)
              this.fieldMessage(errMsg)
              return false
            }
          }
          return true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          return false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    doCancel() {
      this.$router.push({ name: 'tarfPrem' })
    },
    convertDate(date) {
      if (date !== null) {
        return formatDisplayDate(date)
      }
    }
  },
  created() {
    const jsonData = JSON.parse(sessionStorage.getItem('tariffPrem'))
    this.$store.commit('TARIFF_PREM_COMMIT_KEY', jsonData)

    if (this.tariffPremId.tranMode !== '') {
      if (this.tariffPremId.tranMode === 'New') {
        this.newMode = true
      } else if (this.tariffPremId.tranMode === 'Review') {
        this.reviewMode = true
      } else if (this.tariffPremId.tranMode === 'Query') {
        this.queryMode = true
      }
    }

    this.$validator.extend('valExpiry', {
      getMessage(field, args) {
        return 'Expiry Date must be equal or greater than Effective Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var expDate = args[0]
        if (expDate) {
          return !isAfter(removeTime(expDate), removeTime(value))
        }
      }
    })
  },
  computed: {
    menu() {
      return this.$store.state.tariffPremParam.menu
    },
    newTariffPrem() {
      return this.tariffPremId.tranMode === 'New'
    },
    tariffPremId() {
      return this.$store.state.tariffPremParam.tarfPrem.tarfPremId
    },
    expDateValidation() {
      if (this.tariffPremForm.expDate !== '' && this.tariffPremForm.expDate !== null) {
        return 'entry|valExpiry:' + this.tariffPremForm.effDate
      } else {
        return ''
      }
    },
    filterTariffList() {
      return this.tariff.filter((list) => {
        return list.value === this.tariffPremForm.tariff
      })
    },
    filterBusClsList() {
      return this.buscls.filter((list) => {
        return list.value === this.tariffPremForm.busCls
      })
    },
    filterBenefitList() {
      return this.benefit.filter((list) => {
        return list.value === this.tariffPremForm.benefit
      })
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [MessageMixin, commonAjaxMixin]
}
</script>
